import { render, staticRenderFns } from "./NaverShoppingConfigIframe.vue?vue&type=template&id=ff9d2ca4&"
import script from "./NaverShoppingConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./NaverShoppingConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports